import { connect } from 'react-redux'
import Drives from 'modules/Drives/index'
import selector from 'modules/Drives/selectors'
import { getDrivesList } from 'modules/Drives/actions'
import { getStudentData} from 'modules/Resume/actions'
import selectorOB from 'modules/Onboarding/selectors'
const mapStateToProps = state => ({
    drivesList: selector.getDrivesList(state),
    driveDateList : selector.getDriveDateCalender(state),
    studentDetails: selectorOB.getStudentResumeData(state),
})

const mapDispatchToProps = {
    getDrivesList,
    getStudentData
}


export default connect(mapStateToProps, mapDispatchToProps)(Drives)
